<template>
  <div class="profil-container" v-if="bank && bank.length > 0">
    <h3 class="profil-title">
      <span v-if="isEdit" class="editRow" @click="editRow(bank[0])"><span class="fa fa-edit pointer ml20"></span></span>
      {{ bank[0].text }}
    </h3>
    <p class="profil-subtitle">
      <span v-if="isEdit" class="editRow" @click="editRow(bank[1])"><span class="fa fa-edit pointer ml20"></span></span>
      {{ bank[1].text }}
    </p>

    <div class="vendor-form-wrapper">
      <div v-for="(item, index) in bank.slice(2)" :key="index" class="vendor-form">
        <span v-if="isEdit" class="editRow" @click="editRow(item)"><span class="fa fa-edit pointer ml20"></span></span>

        <p class="vendor-form-label">
          {{ item.text }}<span v-if="item.is_mandatory" class="text-ast">*</span>
        </p>

        <input v-if="item.name === 'Bank-3'" type="text" class="vendor-input" placeholder="NAMA VENDOR" />

        <input v-if="item.name === 'Bank-4' || item.name === 'Bank-5'" type="text" class="vendor-input" />

        <input v-if="item.name === 'Bank-6'" type="number" class="vendor-input" />

        <div v-if="item.name === 'Bank-7'" class="vendor-input">
          <v-select class="style-chooser" placeholder="Pilih Mata Uang" label="kode_mata_uang" autocomplete="negara" />
        </div>

        <the-mask v-if="item.name === 'Bank-8'" class="vendor-input" :mask="['##.###.###.#-###.###']"
          placeholder="XX.XXX.XXX.X-XXX.XXX" />

        <input v-if="item.question_type !== 'default' && item.question_type === 'text'" type="text"
          class="vendor-input" />
        <textarea v-if="item.question_type !== 'default' && item.question_type === 'textarea'" class="vendor-input" />
        <div class="vendor-input flex-row" v-if="item.question_type !== 'default' && item.question_type === 'radio'">
          <div class="input-20">
            <input type="radio" name="ya" value="ya" v-model="item.value" />
            <label class="ml20" for="ya">Ya</label>
          </div>
          <div class="input-20">
            <input type="radio" name="tidak" value="tidak" v-model="item.value" />
            <label class="ml20" for="tidak">Tidak</label>
          </div>
        </div>
        <input v-if="item.question_type !== 'default' && item.question_type === 'date-picker'" type="date"
          class="vendor-input" />
        <div v-if="item.question_type !== 'default' && item.question_type === 'date-range'" class="vendor-input">
          <input type="date" class="w-50" />
          <input type="date" class="w-50" />
        </div>
        <input v-if="item.question_type !== 'default' && item.question_type === 'attachment'" type="file"
          class="vendor-input" />

      </div>

      <div class="btn-landing-icons" @click="addQuestion">
        <p class="icons-btn-landing">+</p>
        <span class="text-btn-landing">Tambah</span>
      </div>


    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goAfiliasi()" class="btn-landing">Selanjutnya</div>
    </div>
    <EditPertanyaan v-if="showModalEdit" :editData="editData" @closeModal="closeModal" class="notAll" />
    <AddPertanyaan v-if="showModalAdd" @closeModal="closeModalAdd" class="notAll" />
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'bank',
  components: {
    EditPertanyaan: () => import('@/components/masterdata/landing-page/edit/edit-pertanyaan.vue'),
    AddPertanyaan: () => import('@/components/masterdata/landing-page/add/tambah-pertanyaan.vue'),
  },
  props: {
    isEdit: Boolean
  },
  data() {
    return {

      showModalEdit: false,
      showModalAdd: false,
      editData: null,
      bankList: [],
      countryList: [],
    }
  },
  computed: {
    bank() {
      const data = this.$store.state.mdLandingStore.bank
      return data
    },
  },
  methods: {
    editRow(data) {
      this.editData = data
      this.showModalEdit = true
    },

    addQuestion() {
      this.showModalAdd = true;
    },

    closeModalAdd() {
      this.showModalAdd = false;
    },

    closeModal() {
      this.showModalEdit = false
    },

    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'alamat')
    },
    goAfiliasi() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'afiliasi')
    },

  },
}
</script>
